"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.plainTextFormat = void 0;
var utils_1 = require("../utils/utils");
var format_1 = require("./format");
var toString = {}.toString;
var R_PRIMITIVE = /string|number|boolean/i;
var stringify = function (val) {
    try {
        var type = toString.call(val);
        if (R_PRIMITIVE.test(type) || val == null) {
            return val == null ? (val === null ? 'null' : 'undefined') : val;
        }
        return JSON.stringify(val);
    }
    catch (_) {
        return val;
    }
};
exports.plainTextFormat = (0, format_1.createFormat)({ label: {}, level: {} }, function (entry) {
    var values = [];
    if (entry.ts > 0) {
        values.push("[".concat((0, utils_1.timeFormat)(entry.ts), "]"));
    }
    if (entry.badge != null) {
        values.push(entry.badge);
    }
    if (entry.label != null) {
        values.push("(".concat(entry.label, ")"));
    }
    if (entry.args != null) {
        var args = entry.args;
        var n = args.length;
        for (var i = 0; i < n; i++) {
            values.push(stringify(args[i]));
        }
    }
    if (entry.meta != null) {
        values.push("".concat(entry.meta.file, ":").concat(entry.meta.line, ":").concat(entry.meta.col));
    }
    return values;
});
//# sourceMappingURL=plain-text.js.map